import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { OpenInBrowser as OpenInBrowserIcon, Warning as WarningIcon } from '@mui/icons-material';
import { getBrowserName } from '../utils/browserDetection';

const InAppBrowserWarning = () => {
  const browserName = getBrowserName();
  
  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    alert('✅ Link copiado! Cole no Safari ou Chrome');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        background: 'linear-gradient(135deg, #0F1115 0%, #141821 100%)',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: 400,
          p: 3,
          textAlign: 'center',
          backgroundColor: '#1a1f2e',
          border: '1px solid rgba(240, 185, 11, 0.2)',
        }}
      >
        <WarningIcon
          sx={{
            fontSize: 60,
            color: '#F0B90B',
            mb: 2,
          }}
        />
        
        <Typography
          variant="h5"
          sx={{
            color: '#fff',
            fontWeight: 700,
            mb: 2,
            fontFamily: "'Inter', sans-serif",
          }}
        >
          Abra no Navegador
        </Typography>
        
        <Typography
          variant="body1"
          sx={{
            color: 'rgba(255, 255, 255, 0.7)',
            mb: 3,
            lineHeight: 1.6,
          }}
        >
          O navegador do {browserName} tem limitações de segurança. Para acessar o app, abra este link no <strong>Safari</strong> ou <strong>Chrome</strong>.
        </Typography>

        <Box
          sx={{
            backgroundColor: 'rgba(240, 185, 11, 0.1)',
            borderRadius: 2,
            p: 2,
            mb: 3,
            border: '1px dashed rgba(240, 185, 11, 0.3)',
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: '#F0B90B',
              fontWeight: 600,
              mb: 1,
            }}
          >
            📱 Como fazer:
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255, 255, 255, 0.8)',
              textAlign: 'left',
              fontSize: '0.875rem',
            }}
          >
            1. Toque nos <strong>três pontos</strong> (⋯) no canto superior<br/>
            2. Selecione <strong>"Abrir no Navegador"</strong><br/>
            3. Escolha Safari ou Chrome
          </Typography>
        </Box>

        <Button
          variant="contained"
          fullWidth
          startIcon={<OpenInBrowserIcon />}
          onClick={copyLink}
          sx={{
            background: 'linear-gradient(135deg, #F0B90B 0%, #F8D12F 100%)',
            color: '#000',
            fontWeight: 700,
            py: 1.5,
            textTransform: 'none',
            fontSize: '1rem',
            '&:hover': {
              background: 'linear-gradient(135deg, #F8D12F 0%, #F0B90B 100%)',
            },
          }}
        >
          Copiar Link
        </Button>

        <Typography
          variant="caption"
          sx={{
            color: 'rgba(255, 255, 255, 0.5)',
            display: 'block',
            mt: 2,
          }}
        >
          Após copiar, abra Safari/Chrome e cole o link
        </Typography>
      </Paper>
    </Box>
  );
};

export default InAppBrowserWarning;
